import { createAuthFileDownloadQuery } from '../auth-http-client';

export type DownloadShiftReportQueryParams = {
	accountIds: number[];
	cashdeskIds: number[];
	cashierIds: number[];
	currencies: string[];
	dateFrom?: string;
	dateTo?: string;
	timeZone: number;
};

export const createDownloadShiftReportQuery = () =>
	createAuthFileDownloadQuery<DownloadShiftReportQueryParams>({
		url: '/report/shift/download',
		fileName: (params) =>
			params.dateFrom && params.dateTo
				? `shift-report-${params.dateFrom}-${params.dateTo}.xlsx`
				: 'shift-report.xlsx',
	});
